import { steps } from "@/mocks/site";

export default function Guide() {
  return (
    <section
      id="guide"
      className="relative overflow-hidden border-y border-background-200 bg-accent-600 py-14 md:py-20"
    >
      <div className="pointer-events-none absolute -right-10 -top-16 opacity-10">
        <i className="ri-focus-3-line text-[16rem] text-accent-950"></i>
      </div>
      <div className="container-site relative">
        <div className="mx-auto max-w-2xl text-center">
          <p className="mb-1 flex items-center justify-center gap-2 text-sm font-medium text-background-50/90">
            <i className="ri-compass-3-fill"></i> 新手也不迷路
          </p>
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">四步搞定围观</h2>
          <p className="mt-2 text-sm text-background-50/85">
            从找对入口到蹲到后续，一套流程走下来，吃瓜体验更省心。
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, idx) => (
            <div key={s.index} className="relative rounded-2xl bg-background-50 p-6">
              <div className="flex items-center justify-between">
                <span className="font-heading text-3xl font-bold text-secondary-300">{s.index}</span>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
              {idx < 3 && (
                <i className="ri-arrow-right-line absolute -right-4 top-1/2 hidden -translate-y-1/2 text-xl text-background-50/70 lg:block"></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}